module.exports = __webpack_public_path__ + "img/palm-tree-wind.f95d6350.jpg";